
























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import classes from "@/config/wow/classes";

/**
 * Helpers
 */
/**
 * Mixins
 */
/**
 * Components
 */
import TeamCard from "./TeamCard.vue";
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import teamsAPI from "@/api/teams";

import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";
import { GetCreatableGuildsResponse } from "@/api/teams/get-creatable-guilds.response";

/**
 * VueX Modules
 */
const profileModule = namespace("profile");

interface CreateStandaloneTeamForm {
	name: string;
	region: string;
	mustAddMyCharacters: boolean;
}

/**
 * Create a team modal.
 */
@Component({
	components: {
		TeamCard
	}
})
export default class CreateTeamDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections
	imageLinks = imageLinks;
	classes = classes;

	/// Properties
	@Prop()
	onAfterCreate!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	creatableGuilds: GetCreatableGuildsResponse.CreatableGuild[] | null = null;
	stepChoice: number | null = null;

	// Form
	createStandaloneTeamForm: CreateStandaloneTeamForm | null = null;

	/// VueX Modules
	@profileModule.State("userDetails")
	userDetails!: GetCurrentUserResponse;

	get canSubmit() {
		return this.createStandaloneTeamForm && this.createStandaloneTeamForm.name;
	}

	get regions() {
		return [
			{
				value: "eu",
				text: "EU - Europe"
			},
			{
				value: "us",
				text: "US - Americas & Oceania"
			},
			{
				value: "kr",
				text: "KR - Korea"
			},
			{
				value: "tw",
				text: "TW - Taiwan"
			}];
	}

	/// Methods
	async open() {
		this.creatableGuilds = null;
		this.stepChoice = null;

		this.createStandaloneTeamForm = {
			name: "",
			region: "eu",
			mustAddMyCharacters: false
		};

		this.isLoading = true;
		this.$refs.modal.open();
		await this.refreshCreatableTeams();
		this.isLoading = false;
	}

	close() {
		this.$refs.modal.close();
	}

	async refreshCreatableTeams() {
		this.creatableGuilds = await teamsAPI.getCreatableGuilds();
	}

	async handleCreateTeamFromGuildClick(region: string, realm: string, name: string) {
		this.isLoading = true;
		try {
			await teamsAPI.createTeamFromGuild(region, realm, name);
			if (this.onAfterCreate) {
				await this.onAfterCreate();
			}
			this.close();
		} catch (err) {
			this.handleAPIError(err);
		}
		this.isLoading = false;
	}

	async handleCreateTeamClick() {
		this.isLoading = true;
		try {
			if (this.createStandaloneTeamForm != null) {
				await teamsAPI.createTeam({
					name: this.createStandaloneTeamForm.name,
					region: this.createStandaloneTeamForm.region,
					mustAddMyCharacters: this.createStandaloneTeamForm.mustAddMyCharacters
				});
				if (this.onAfterCreate) {
					await this.onAfterCreate();
				}
			}
			this.close();
		} catch (err) {
			this.handleAPIError(err);
		}
		this.isLoading = false;
	}
}
